import Vue from 'vue';
import Vuex from 'vuex';

import operations from '@/modules/operations/store/operations.store.js';
import suiviTva from '@/modules/suivi-tva/store/suivi-tva.store.js';
import marketplace from '@/modules/manage-market-place/store/marketplace.store.js';
import naturesAndComptes from '@/shared-stores/natures-and-comptes.store.js';
import user from '@/shared-stores/user.store.js';
import dossier from '@/shared-stores/dossier.store.js';
import filters from '@/shared-stores/filters.store.js';
import filtersIzzyPilot from '@/shared-stores/filters-izzypilot.store.js';
import emprunts from '@/shared-stores/emprunt.store.js';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    operations,
    naturesAndComptes,
    user,
    dossier,
    filters,
    suiviTva,
    filtersIzzyPilot,
    emprunts,
    marketplace,
  },
  state: {
    // Provided by resources/views/pwa/pwa.blade.php
    // eslint-disable-next-line no-undef
    featureFlags,

    isPWA: true,
    userConnected: null,
    currentDossier: null,
    currentTransaction: {
      amount: null,
      DateEcriture: null,
      libelle_optimise: null,
    },
    suiviTva: [],

    // Prise de photo
    importedFile: null,
    croppedFile: null,
    sendFilesDone: null,
    fromRoute: null,
  },
  getters: {
    userConnected: (state) => state.userConnected,
    currentDossier: (state) => state.currentDossier,
  },
  mutations: {
    SET_USER_CONNECTED(state, currentUser) {
      state.userConnected = currentUser;
    },
    SET_CURRENT_TRANSACTION(state, transaction) {
      state.currentTransaction = transaction;
    },
    SET_IMPORTED_FILE(state, importedFile) {
      state.importedFile = importedFile;
    },
    SET_CROPPED_FILE(state, croppedFile) {
      state.croppedFile = croppedFile;
    },
    SET_SEND_FILES_DONE(state, sendFilesDone) {
      state.sendFilesDone = sendFilesDone;
    },
    SET_FROM_ROUTE(state, fromRoute) {
      state.fromRoute = fromRoute;
    },
  },
  actions: {
    setUserConnected({ commit }, currentUser) {
      commit('SET_USER_CONNECTED', currentUser);
    },
    setCurrentTransaction({ commit }, transaction) {
      commit('SET_CURRENT_TRANSACTION', transaction);
    },
  },
});
